"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_58_0_0 = void 0;
/**
 * Migrate to 58.0.0
 *
 * for old configs with invented article
 *
 */
const migration_58_0_0 = (json) => {
    if (json.Fuehrungsrinnen && json.Fuehrungsrinnen.length) {
        json.Fuehrungsrinnen.forEach((rinne) => {
            if (rinne.IsSet == null && !rinne.ArtNrExists) {
                rinne.IsSet = true;
            }
        });
    }
    if (json.MontageSets && json.MontageSets.length) {
        json.MontageSets.forEach((montagesSet) => {
            if (montagesSet.IsSet == null && !montagesSet.ArtNrExists) {
                montagesSet.IsSet = true;
            }
        });
    }
    if (json.Zugentlastungen && json.Zugentlastungen.length) {
        json.Zugentlastungen.forEach((zugentlastung) => {
            if (zugentlastung.Sets != null) {
                zugentlastung.IsSet = zugentlastung.Sets;
                delete zugentlastung.Sets;
            }
            if (zugentlastung.IsSet == null && !zugentlastung.ArtNrExists) {
                zugentlastung.IsSet = false;
            }
        });
    }
    return json;
};
exports.migration_58_0_0 = migration_58_0_0;
//# sourceMappingURL=migration_58_0_0.js.map